module.exports = __webpack_public_path__ + "img/backyard-garden-with-flowers.0a4bad82.jpg";